import React from 'react';
import { classes } from './ChartTooltip.st.css.js';
import Popover from '../Popover';
import { dataHooks } from './constants';
import Text from '../Text';
export const ChartTooltip = props => {
    const { dataPoint } = props;
    return (React.createElement("div", { className: classes.absolutePosition, style: {
            left: dataPoint.xCoordinate,
            top: dataPoint.yCoordinate,
        } },
        React.createElement(Popover, { theme: "dark", showArrow: true, shown: true, appendTo: "window", placement: "top", fluid: true, dataHooks: dataHooks.chartPopover },
            React.createElement(Popover.Element, null, null),
            React.createElement(Popover.Content, null,
                React.createElement("div", { className: classes.contentWrapper },
                    React.createElement(Text, null, dataPoint.content))))));
};
//# sourceMappingURL=ChartTooltip.js.map